import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../dto/dto.js';
import { PhotoReference } from './file-reference/photo-reference.js';

export class PhotoCollection extends DataModel {
  static readonly TYPE_ID: string = '00d2ea3c2dff49fc9dd8851d6da3fd14';

  constructor(
    public readonly storagePath: string,
    public readonly uploadKey: string,
    public readonly photos: PhotoReference[],
  ) {
    super();
  }

  get $typeId() {
    return PhotoCollection.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PhotoCollection {
    return new PhotoCollection(
        MapUtils.get<string>(map, 'storagePath'),
        MapUtils.get<string>(map, 'uploadKey'),
        MapUtils.getList<PhotoReference>(
            map,
            'photos',
            (value: unknown) => context.fromData<PhotoReference>(value as SerializedData),
        ),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'storagePath': this.storagePath,
      'uploadKey': this.uploadKey,
      'photos': this.photos.map((p) => context.toData<PhotoReference>(p)),
    };
  }

  clone(): this {
    return new PhotoCollection(
        this.storagePath,
        this.uploadKey,
        this.photos.map((e) => e.clone()),
    ) as this;
  }

  isSame(other: PhotoCollection): boolean {
    if(other === this) {
      return true;
    }

    return other.storagePath === this.storagePath &&
      other.uploadKey === this.uploadKey &&
      isSameList(other.photos, this.photos, isSameData);
  }

  copyWith(data: Partial<PhotoCollection>): this {
    return new PhotoCollection(
        data.storagePath ?? this.storagePath,
        data.uploadKey ?? this.uploadKey,
        data.photos ?? this.photos.map((e) => e.clone()),
    ) as this;
  }
}

export class PhotoCollectionBuilder extends DataModelBuilder<PhotoCollection> {
  build(context: SerializationContext, map: SerializedData): PhotoCollection {
    return PhotoCollection.fromMap(context, map);
  }
}
